import FanHomePage from "./FanHomePage";

export default FanHomePage;
